
  export const modelNotification = {
    createdAt: "N/A",
    status: "new",
    action: "view"
  }

  export const initState = {
    notifications: {
        dataRows: []
    }
  }


  export default (state = initState, action) => {
    const { notifications } = state;
    switch (action.type) {
      case 'NOTIFICATIONS_ADD':
        return {
          ...state,
          notifications: {
            dataRows: [ ...notifications.dataRows, { ...modelNotification, ...action.data, nid: action.nid } ]
          }
        }
      case 'NOTIFICATIONS_MODIFY':
        return {
          ...state,
          notifications: {
            dataRows: notifications.dataRows.map( row => row.nid === action.nid ? { ...row, ...action.data } : row),
          },
        }
      case 'NOTIFICATIONS_REMOVE':
        console.log('tryinggggggg', action)
        return {
          ...state,
          notifications: {
            dataRows: notifications.dataRows.filter(row => row.nid !== action.nid)
          }
        }
      default:
        return state
    }
  }
